import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { esSoloLectura } from "./roles";

/**
 * Action constants for the bitácora (audit log).
 */
export const BITACORA_ACTIONS = {
  // Events
  EVENT_CREATE: "event.create",
  EVENT_EDIT: "event.edit",
  EVENT_DELETE: "event.delete",
  EVENT_CANCEL: "event.cancel",
  EVENT_REACTIVATE: "event.reactivate",
  EVENT_EDIT_NOTES: "event.edit_notes",
  EVENT_EDIT_PRECIO: "event.edit_precio",
  EVENT_EDIT_DESGLOSE: "event.edit_desglose",
  EVENT_TOGGLE_IVA: "event.toggle_iva",
  EVENT_NOTA_CREATE: "event.nota_create",
  EVENT_NOTA_EDIT: "event.nota_edit",
  EVENT_NOTA_DELETE: "event.nota_delete",
  EVENT_ARCHIVO_UPLOAD: "event.archivo_upload",
  EVENT_ARCHIVO_DELETE: "event.archivo_delete",
  PAYMENT_COMPROBANTE_ATTACH: "payment.comprobante_attach",
  PAYMENT_COMPROBANTE_DELETE: "payment.comprobante_delete",
  REFUND_COMPROBANTE_ATTACH: "refund.comprobante_attach",
  REFUND_COMPROBANTE_DELETE: "refund.comprobante_delete",
  DEPOSITO_COMPROBANTE_ATTACH: "deposito.comprobante_attach",
  DEPOSITO_COMPROBANTE_DELETE: "deposito.comprobante_delete",
  COSTO_COMPROBANTE_ATTACH: "costo.comprobante_attach",
  COSTO_COMPROBANTE_DELETE: "costo.comprobante_delete",
  // Payments
  PAYMENT_CREATE: "payment.create",
  PAYMENT_DELETE: "payment.delete",
  PAYMENT_EDIT_AMOUNT: "payment.edit_amount",
  PAYMENT_EDIT_METHOD: "payment.edit_method",
  PAYMENT_EDIT_NOTES: "payment.edit_notes",
  // Refunds
  REFUND_CREATE: "refund.create",
  REFUND_DELETE: "refund.delete",
  REFUND_EDIT_AMOUNT: "refund.edit_amount",
  REFUND_EDIT_METHOD: "refund.edit_method",
  REFUND_EDIT_NOTES: "refund.edit_notes",
  // Costos
  COSTO_CREATE: "costo.create",
  COSTO_DELETE: "costo.delete",
  COSTO_EDIT: "costo.edit",
  COSTO_TOGGLE_ESTADO: "costo.toggle_estado",
  COSTO_SALDO_FAVOR_APLICAR: "costo.saldo_favor_aplicar",
  COSTO_SALDO_FAVOR_DEVUELTO: "costo.saldo_favor_devuelto",
  PROVEEDOR_COSTO_UPDATE: "proveedor.costo_update",
  // Retiros del dueño (repartición de utilidades; FRA-343)
  RETIRO_CREATE: "retiro.create",
  RETIRO_DELETE: "retiro.delete",
  // Servicios del venue (catálogo, FRA-347)
  SERVICIO_CREATE: "servicio.create",
  SERVICIO_EDIT: "servicio.edit",
  SERVICIO_DELETE: "servicio.delete",
  SERVICIO_ARCHIVE: "servicio.archive",
  SERVICIO_UNARCHIVE: "servicio.unarchive",
  SERVICIO_CLASIFICAR: "servicio.clasificar",
  SERVICIO_VARIANTE_CREATE: "servicio.variante_create",
  SERVICIO_INCLUIDO_SET: "servicio.incluido_set",
  // Inventario del servicio
  SERVICIO_COSTO_UPDATE: "servicio.costo_update",
  SERVICIO_COMPRA: "servicio.compra",
  SERVICIO_CONSUMO: "servicio.consumo",
  SERVICIO_AJUSTE: "servicio.ajuste",
  SERVICIO_UNIDAD_CREATE: "servicio.unidad_create",
  SERVICIO_UNIDAD_EDIT: "servicio.unidad_edit",
  SERVICIO_UNIDAD_DELETE: "servicio.unidad_delete",
  SERVICIO_UNIDAD_RECARGA: "servicio.unidad_recarga",
  EVENT_SERVICIO_ASSIGN: "event.servicio_assign",
  EVENT_SERVICIO_UNASSIGN: "event.servicio_unassign",
  // Leads
  LEAD_CREATE: "lead.create",
  LEAD_EDIT: "lead.edit",
  LEAD_STATUS_CHANGE: "lead.status_change",
  LEAD_EDIT_NOTES: "lead.edit_notes",
  LEAD_DELETE: "lead.delete",
  LEAD_EDIT_COLUMNS: "lead.edit_columns",
  LEAD_ADD_DATE: "lead.add_date",
  LEAD_REMOVE_DATE: "lead.remove_date",
  LEAD_EDIT_DESGLOSE: "lead.edit_desglose",
  LEAD_TOGGLE_IVA: "lead.toggle_iva",
  LEAD_COTIZACION_GENERATE: "lead.cotizacion_generate",
  LEAD_CONVERT: "lead.convert",
  LEAD_STATS_EXPORT_PDF: "lead.stats_export_pdf",
  LEAD_STATS_EXPORT_CSV: "lead.stats_export_csv",
  LEAD_NOTA_CREATE: "lead.nota_create",
  LEAD_NOTA_EDIT: "lead.nota_edit",
  LEAD_NOTA_DELETE: "lead.nota_delete",
  // Venue
  VENUE_EDIT: "venue.edit",
  VENUE_EVENTOS_SIMULTANEOS_TOGGLE: "venue.eventos_simultaneos_toggle",
  // Espacios (multiespacio)
  ESPACIO_CREATE: "espacio.create",
  ESPACIO_EDIT: "espacio.edit",
  ESPACIO_DELETE: "espacio.delete",
  ESPACIO_INCOMPATIBILIDAD_EDIT: "espacio.incompatibilidad_edit",
  // Galerías de eventos (multiespacio)
  GALERIA_CREATE: "galeria.create",
  GALERIA_EDIT: "galeria.edit",
  GALERIA_DELETE: "galeria.delete",
  // Telegram (bot de owners)
  TELEGRAM_LINK_GROUP: "telegram.link_group",
  TELEGRAM_UNLINK_GROUP: "telegram.unlink_group",
  TELEGRAM_TOGGLE_SCOPE: "telegram.toggle_scope",
  TELEGRAM_IDENTIFY_GROUP: "telegram.identify_group",
  // Conceptos
  CONCEPTO_CREATE: "concepto.create",
  CONCEPTO_DELETE: "concepto.delete",
  CONCEPTO_EDIT: "concepto.edit",
  // Métodos de pago
  METODO_PAGO_CREATE: "metodo_pago.create",
  METODO_PAGO_DELETE: "metodo_pago.delete",
  // Cotizaciones
  COTIZACION_GENERATE: "cotizacion.generate",
  COTIZACION_MARK_SENT: "cotizacion.mark_sent",
  // Proveedores
  PROVEEDOR_CREATE: "proveedor.create",
  PROVEEDOR_EDIT: "proveedor.edit",
  PROVEEDOR_DELETE: "proveedor.delete",
  PROVEEDOR_ARCHIVE: "proveedor.archive",
  PROVEEDOR_UNARCHIVE: "proveedor.unarchive",
  PROVEEDOR_CONTACTO_ADD: "proveedor.contacto_add",
  PROVEEDOR_CONTACTO_EDIT: "proveedor.contacto_edit",
  PROVEEDOR_CONTACTO_DELETE: "proveedor.contacto_delete",
  PROVEEDOR_REVIEW_CREATE: "proveedor.review_create",
  PROVEEDOR_REVIEW_EDIT: "proveedor.review_edit",
  PROVEEDOR_REVIEW_DELETE: "proveedor.review_delete",
  EVENT_PROVEEDOR_ASSIGN: "event.proveedor_assign",
  EVENT_PROVEEDOR_UNASSIGN: "event.proveedor_unassign",
  EVENT_PLANNER_ASSIGN: "event.planner_assign",
  EVENT_PLANNER_UNASSIGN: "event.planner_unassign",
  PROVEEDOR_DEPOSITO_CREATE: "proveedor.deposito_create",
  PROVEEDOR_DEPOSITO_EDIT: "proveedor.deposito_edit",
  PROVEEDOR_DEPOSITO_DELETE: "proveedor.deposito_delete",
  PROVEEDOR_DEPOSITO_DEVOLUCION: "proveedor.deposito_devolucion",
  PROVEEDOR_DEPOSITO_COBRO: "proveedor.deposito_cobro",
  PROVEEDOR_DEPOSITO_REACTIVAR: "proveedor.deposito_reactivar",
  EVENTO_DEPOSITO_CREATE: "evento.deposito_create",
  EVENTO_DEPOSITO_EDIT: "evento.deposito_edit",
  EVENTO_DEPOSITO_DELETE: "evento.deposito_delete",
  EVENTO_DEPOSITO_DEVOLUCION: "evento.deposito_devolucion",
  EVENTO_DEPOSITO_APLICADO: "evento.deposito_aplicado",
  EVENTO_DEPOSITO_REACTIVAR: "evento.deposito_reactivar",
  CLIENTE_CREATE: "cliente.create",
  CLIENTE_EDIT: "cliente.edit",
  CLIENTE_ARCHIVE: "cliente.archive",
  CLIENTE_UNARCHIVE: "cliente.unarchive",
  CLIENTE_BACKFILL: "cliente.backfill",
  EVENT_CLIENTE_LINK: "event.cliente_link",
  EVENT_CLIENTE_UNLINK: "event.cliente_unlink",
  EVENT_CLIENTE_ROL: "event.cliente_rol",
  PROVEEDOR_COMISION_UPDATE: "proveedor.comision_update",
  EVENT_COMISION_CREATE: "event.comision_create",
  RECURRENTE_CREATE: "recurrente.create",
  RECURRENTE_EDIT: "recurrente.edit",
  RECURRENTE_ARCHIVE: "recurrente.archive",
  RECURRENTE_CONFIRMAR: "recurrente.confirmar",
  RECURRENTE_SALTAR: "recurrente.saltar",
  PROVEEDOR_NOTA_CREATE: "proveedor.nota_create",
  PROVEEDOR_NOTA_EDIT: "proveedor.nota_edit",
  PROVEEDOR_NOTA_DELETE: "proveedor.nota_delete",
  PROVEEDOR_COMENTARIO_CREATE: "proveedor.comentario_create",
  PROVEEDOR_COMENTARIO_EDIT: "proveedor.comentario_edit",
  PROVEEDOR_COMENTARIO_DELETE: "proveedor.comentario_delete",
};

const ACTION_LABELS = {
  [BITACORA_ACTIONS.EVENT_CREATE]: "Evento creado",
  [BITACORA_ACTIONS.EVENT_EDIT]: "Evento editado",
  [BITACORA_ACTIONS.EVENT_DELETE]: "Evento eliminado",
  [BITACORA_ACTIONS.EVENT_CANCEL]: "Evento cancelado",
  [BITACORA_ACTIONS.EVENT_REACTIVATE]: "Evento reactivado",
  [BITACORA_ACTIONS.EVENT_EDIT_NOTES]: "Notas de evento editadas",
  [BITACORA_ACTIONS.EVENT_EDIT_PRECIO]: "Precio de evento editado",
  [BITACORA_ACTIONS.EVENT_EDIT_DESGLOSE]: "Desglose de evento editado",
  [BITACORA_ACTIONS.EVENT_TOGGLE_IVA]: "IVA de evento actualizado",
  [BITACORA_ACTIONS.EVENT_NOTA_CREATE]: "Nota de evento agregada",
  [BITACORA_ACTIONS.EVENT_NOTA_EDIT]: "Nota de evento editada",
  [BITACORA_ACTIONS.EVENT_NOTA_DELETE]: "Nota de evento eliminada",
  [BITACORA_ACTIONS.EVENT_ARCHIVO_UPLOAD]: "Archivo de evento subido",
  [BITACORA_ACTIONS.EVENT_ARCHIVO_DELETE]: "Archivo de evento eliminado",
  [BITACORA_ACTIONS.PAYMENT_COMPROBANTE_ATTACH]: "Comprobante de pago adjuntado",
  [BITACORA_ACTIONS.PAYMENT_COMPROBANTE_DELETE]: "Comprobante de pago eliminado",
  [BITACORA_ACTIONS.REFUND_COMPROBANTE_ATTACH]: "Comprobante de reembolso adjuntado",
  [BITACORA_ACTIONS.REFUND_COMPROBANTE_DELETE]: "Comprobante de reembolso eliminado",
  [BITACORA_ACTIONS.DEPOSITO_COMPROBANTE_ATTACH]: "Comprobante de depósito adjuntado",
  [BITACORA_ACTIONS.DEPOSITO_COMPROBANTE_DELETE]: "Comprobante de depósito eliminado",
  [BITACORA_ACTIONS.COSTO_COMPROBANTE_ATTACH]: "Comprobante de egreso adjuntado",
  [BITACORA_ACTIONS.COSTO_COMPROBANTE_DELETE]: "Comprobante de egreso eliminado",
  [BITACORA_ACTIONS.PAYMENT_CREATE]: "Pago registrado",
  [BITACORA_ACTIONS.PAYMENT_DELETE]: "Pago eliminado",
  [BITACORA_ACTIONS.PAYMENT_EDIT_AMOUNT]: "Monto de pago editado",
  [BITACORA_ACTIONS.PAYMENT_EDIT_METHOD]: "Método de pago editado",
  [BITACORA_ACTIONS.PAYMENT_EDIT_NOTES]: "Notas de pago editadas",
  [BITACORA_ACTIONS.REFUND_CREATE]: "Reembolso registrado",
  [BITACORA_ACTIONS.REFUND_DELETE]: "Reembolso eliminado",
  [BITACORA_ACTIONS.REFUND_EDIT_AMOUNT]: "Monto de reembolso editado",
  [BITACORA_ACTIONS.REFUND_EDIT_METHOD]: "Método de reembolso editado",
  [BITACORA_ACTIONS.REFUND_EDIT_NOTES]: "Notas de reembolso editadas",
  [BITACORA_ACTIONS.COSTO_CREATE]: "Costo registrado",
  [BITACORA_ACTIONS.COSTO_DELETE]: "Costo eliminado",
  [BITACORA_ACTIONS.COSTO_EDIT]: "Costo editado",
  [BITACORA_ACTIONS.COSTO_TOGGLE_ESTADO]: "Estado de costo cambiado",
  [BITACORA_ACTIONS.PROVEEDOR_COSTO_UPDATE]: "Tarifa de proveedor actualizada",
  [BITACORA_ACTIONS.RETIRO_CREATE]: "Retiro registrado",
  [BITACORA_ACTIONS.RETIRO_DELETE]: "Retiro eliminado",
  [BITACORA_ACTIONS.SERVICIO_CREATE]: "Servicio creado",
  [BITACORA_ACTIONS.SERVICIO_EDIT]: "Servicio editado",
  [BITACORA_ACTIONS.SERVICIO_DELETE]: "Servicio eliminado",
  [BITACORA_ACTIONS.SERVICIO_ARCHIVE]: "Servicio archivado",
  [BITACORA_ACTIONS.SERVICIO_UNARCHIVE]: "Servicio restaurado",
  [BITACORA_ACTIONS.SERVICIO_CLASIFICAR]: "Servicio clasificado",
  [BITACORA_ACTIONS.SERVICIO_VARIANTE_CREATE]: "Variante de servicio creada desde la cotización",
  [BITACORA_ACTIONS.SERVICIO_INCLUIDO_SET]: "Servicio acomodado en las rentas que lo incluyen",
  // Retiradas con el inventario consumible: ya nada las escribe, pero la
  // bitácora es append-only y las entradas viejas tienen que seguir leyéndose.
  [BITACORA_ACTIONS.SERVICIO_COSTO_UPDATE]: "Costo unitario del consumible actualizado",
  [BITACORA_ACTIONS.SERVICIO_COMPRA]: "Compra de consumible registrada",
  [BITACORA_ACTIONS.SERVICIO_CONSUMO]: "Consumo de inventario registrado",
  [BITACORA_ACTIONS.SERVICIO_AJUSTE]: "Inventario ajustado",
  [BITACORA_ACTIONS.SERVICIO_UNIDAD_CREATE]: "Pieza de servicio creada",
  [BITACORA_ACTIONS.SERVICIO_UNIDAD_EDIT]: "Pieza de servicio editada",
  [BITACORA_ACTIONS.SERVICIO_UNIDAD_DELETE]: "Pieza de servicio eliminada",
  [BITACORA_ACTIONS.SERVICIO_UNIDAD_RECARGA]: "Pieza recargada", // retirada, ver arriba
  [BITACORA_ACTIONS.EVENT_SERVICIO_ASSIGN]: "Servicio asignado al evento",
  [BITACORA_ACTIONS.EVENT_SERVICIO_UNASSIGN]: "Servicio removido del evento",
  [BITACORA_ACTIONS.LEAD_CREATE]: "Lead creado",
  [BITACORA_ACTIONS.LEAD_EDIT]: "Lead editado",
  [BITACORA_ACTIONS.LEAD_STATUS_CHANGE]: "Estado de lead cambiado",
  [BITACORA_ACTIONS.LEAD_EDIT_NOTES]: "Notas de lead editadas",
  [BITACORA_ACTIONS.LEAD_DELETE]: "Lead eliminado",
  [BITACORA_ACTIONS.LEAD_EDIT_COLUMNS]: "Columnas de leads editadas",
  [BITACORA_ACTIONS.LEAD_ADD_DATE]: "Fecha de interés agregada",
  [BITACORA_ACTIONS.LEAD_REMOVE_DATE]: "Fecha de interés eliminada",
  [BITACORA_ACTIONS.LEAD_EDIT_DESGLOSE]: "Desglose de lead editado",
  [BITACORA_ACTIONS.LEAD_TOGGLE_IVA]: "IVA de lead actualizado",
  [BITACORA_ACTIONS.LEAD_COTIZACION_GENERATE]: "Cotización de lead generada",
  [BITACORA_ACTIONS.LEAD_CONVERT]: "Lead convertido a evento",
  [BITACORA_ACTIONS.LEAD_STATS_EXPORT_PDF]: "Reporte de leads (PDF) descargado",
  [BITACORA_ACTIONS.LEAD_STATS_EXPORT_CSV]: "Leads exportados a CSV",
  [BITACORA_ACTIONS.LEAD_NOTA_CREATE]: "Nota de lead agregada",
  [BITACORA_ACTIONS.LEAD_NOTA_EDIT]: "Nota de lead editada",
  [BITACORA_ACTIONS.LEAD_NOTA_DELETE]: "Nota de lead eliminada",
  [BITACORA_ACTIONS.VENUE_EDIT]: "Venue editado",
  [BITACORA_ACTIONS.VENUE_EVENTOS_SIMULTANEOS_TOGGLE]: "Eventos simultáneos del venue actualizados",
  [BITACORA_ACTIONS.ESPACIO_CREATE]: "Espacio creado",
  [BITACORA_ACTIONS.ESPACIO_EDIT]: "Espacio editado",
  [BITACORA_ACTIONS.ESPACIO_DELETE]: "Espacio eliminado",
  [BITACORA_ACTIONS.ESPACIO_INCOMPATIBILIDAD_EDIT]: "Incompatibilidad de espacios editada",
  [BITACORA_ACTIONS.GALERIA_CREATE]: "Galería de eventos creada",
  [BITACORA_ACTIONS.GALERIA_EDIT]: "Galería de eventos editada",
  [BITACORA_ACTIONS.GALERIA_DELETE]: "Galería de eventos eliminada",
  [BITACORA_ACTIONS.TELEGRAM_LINK_GROUP]: "Grupo de Telegram vinculado",
  [BITACORA_ACTIONS.TELEGRAM_UNLINK_GROUP]: "Grupo de Telegram desvinculado",
  [BITACORA_ACTIONS.TELEGRAM_TOGGLE_SCOPE]: "Permisos de grupo de Telegram editados",
  [BITACORA_ACTIONS.TELEGRAM_IDENTIFY_GROUP]: "Grupo de Telegram identificado",
  [BITACORA_ACTIONS.CONCEPTO_CREATE]: "Concepto creado",
  [BITACORA_ACTIONS.CONCEPTO_DELETE]: "Concepto eliminado",
  [BITACORA_ACTIONS.CONCEPTO_EDIT]: "Concepto editado",
  [BITACORA_ACTIONS.METODO_PAGO_CREATE]: "Método de pago creado",
  [BITACORA_ACTIONS.METODO_PAGO_DELETE]: "Método de pago eliminado",
  [BITACORA_ACTIONS.COTIZACION_GENERATE]: "Cotización generada",
  [BITACORA_ACTIONS.COTIZACION_MARK_SENT]: "Cotización marcada como enviada",
  [BITACORA_ACTIONS.PROVEEDOR_CREATE]: "Proveedor creado",
  [BITACORA_ACTIONS.PROVEEDOR_EDIT]: "Proveedor editado",
  [BITACORA_ACTIONS.PROVEEDOR_DELETE]: "Proveedor eliminado",
  [BITACORA_ACTIONS.PROVEEDOR_ARCHIVE]: "Proveedor archivado",
  [BITACORA_ACTIONS.PROVEEDOR_UNARCHIVE]: "Proveedor desarchivado",
  [BITACORA_ACTIONS.PROVEEDOR_CONTACTO_ADD]: "Contacto agregado al proveedor",
  [BITACORA_ACTIONS.PROVEEDOR_CONTACTO_EDIT]: "Contacto de proveedor editado",
  [BITACORA_ACTIONS.PROVEEDOR_CONTACTO_DELETE]: "Contacto de proveedor eliminado",
  [BITACORA_ACTIONS.PROVEEDOR_REVIEW_CREATE]: "Reseña de proveedor agregada",
  [BITACORA_ACTIONS.PROVEEDOR_REVIEW_EDIT]: "Reseña de proveedor editada",
  [BITACORA_ACTIONS.PROVEEDOR_REVIEW_DELETE]: "Reseña de proveedor eliminada",
  [BITACORA_ACTIONS.EVENT_PROVEEDOR_ASSIGN]: "Proveedor asignado al evento",
  [BITACORA_ACTIONS.EVENT_PROVEEDOR_UNASSIGN]: "Proveedor removido del evento",
  [BITACORA_ACTIONS.EVENT_PLANNER_ASSIGN]: "Planner asignado al evento",
  [BITACORA_ACTIONS.EVENT_PLANNER_UNASSIGN]: "Planner removido del evento",
  [BITACORA_ACTIONS.PROVEEDOR_DEPOSITO_CREATE]: "Depósito en garantía registrado",
  [BITACORA_ACTIONS.PROVEEDOR_DEPOSITO_EDIT]: "Depósito en garantía editado",
  [BITACORA_ACTIONS.PROVEEDOR_DEPOSITO_DELETE]: "Depósito en garantía eliminado",
  [BITACORA_ACTIONS.PROVEEDOR_DEPOSITO_DEVOLUCION]: "Devolución de depósito registrada",
  [BITACORA_ACTIONS.PROVEEDOR_DEPOSITO_COBRO]: "Depósito aplicado por el venue",
  [BITACORA_ACTIONS.PROVEEDOR_DEPOSITO_REACTIVAR]: "Depósito reactivado (vuelve a custodia)",
  [BITACORA_ACTIONS.EVENTO_DEPOSITO_CREATE]: "Depósito en garantía (cliente) registrado",
  [BITACORA_ACTIONS.EVENTO_DEPOSITO_EDIT]: "Depósito en garantía (cliente) editado",
  [BITACORA_ACTIONS.EVENTO_DEPOSITO_DELETE]: "Depósito en garantía (cliente) eliminado",
  [BITACORA_ACTIONS.EVENTO_DEPOSITO_DEVOLUCION]: "Devolución de depósito (cliente) registrada",
  [BITACORA_ACTIONS.EVENTO_DEPOSITO_APLICADO]: "Depósito (cliente) aplicado por daños",
  [BITACORA_ACTIONS.EVENTO_DEPOSITO_REACTIVAR]: "Depósito (cliente) reactivado (vuelve a custodia)",
  [BITACORA_ACTIONS.CLIENTE_CREATE]: "Cliente creado",
  [BITACORA_ACTIONS.CLIENTE_EDIT]: "Cliente editado",
  [BITACORA_ACTIONS.CLIENTE_ARCHIVE]: "Cliente archivado",
  [BITACORA_ACTIONS.CLIENTE_UNARCHIVE]: "Cliente desarchivado",
  [BITACORA_ACTIONS.CLIENTE_BACKFILL]: "Directorio de clientes armado desde eventos",
  [BITACORA_ACTIONS.EVENT_CLIENTE_LINK]: "Evento ligado a cliente",
  [BITACORA_ACTIONS.EVENT_CLIENTE_UNLINK]: "Evento desligado de cliente",
  [BITACORA_ACTIONS.EVENT_CLIENTE_ROL]: "Rol de cliente en evento",
  [BITACORA_ACTIONS.PROVEEDOR_COMISION_UPDATE]: "Acuerdo de comisión actualizado",
  [BITACORA_ACTIONS.EVENT_COMISION_CREATE]: "Comisión de planner registrada",
  [BITACORA_ACTIONS.RECURRENTE_CREATE]: "Gasto recurrente creado",
  [BITACORA_ACTIONS.RECURRENTE_EDIT]: "Gasto recurrente editado",
  [BITACORA_ACTIONS.RECURRENTE_ARCHIVE]: "Gasto recurrente archivado",
  [BITACORA_ACTIONS.RECURRENTE_CONFIRMAR]: "Gasto recurrente confirmado",
  [BITACORA_ACTIONS.RECURRENTE_SALTAR]: "Ocurrencia de gasto recurrente saltada",
  [BITACORA_ACTIONS.PROVEEDOR_NOTA_CREATE]: "Nota de proveedor agregada",
  [BITACORA_ACTIONS.PROVEEDOR_NOTA_EDIT]: "Nota de proveedor editada",
  [BITACORA_ACTIONS.PROVEEDOR_NOTA_DELETE]: "Nota de proveedor eliminada",
  [BITACORA_ACTIONS.PROVEEDOR_COMENTARIO_CREATE]: "Comentario en evento agregado",
  [BITACORA_ACTIONS.PROVEEDOR_COMENTARIO_EDIT]: "Comentario en evento editado",
  [BITACORA_ACTIONS.PROVEEDOR_COMENTARIO_DELETE]: "Comentario en evento eliminado",
};

export function getActionLabel(action) {
  return ACTION_LABELS[action] || action;
}

export const ENTITY_LABELS = {
  event: "Evento",
  payment: "Pago",
  refund: "Reembolso",
  costo: "Costo",
  servicio: "Servicio",
  servicio_unidad: "Pieza de servicio",
  lead: "Lead",
  venue: "Venue",
  concepto: "Concepto",
  metodo_pago: "Método de pago",
  lead_columns: "Columnas de leads",
  lead_nota: "Nota de lead",
  event_nota: "Nota de evento",
  cotizacion: "Cotización",
  proveedor: "Proveedor",
  proveedor_contacto: "Contacto de proveedor",
  proveedor_review: "Reseña de proveedor",
  proveedor_deposito: "Depósito en garantía",
  evento_deposito: "Depósito en garantía (cliente)",
  proveedor_nota: "Nota de proveedor",
  cliente: "Cliente",
  recurrente: "Gasto recurrente",
  proveedor_comentario: "Comentario en evento",
  telegram_chat: "Grupo de Telegram",
  espacio: "Espacio",
  galeria: "Galería de eventos",
};

/**
 * Logs an action to the venue's bitácora subcollection.
 * Fire-and-forget — does not await. Skips if user is admin.
 *
 * @param {string} venueId
 * @param {object} logData - { action, entity, entityId, entityName, details }
 * @param {object} userInfo - from useAuth() — must have .role, .name
 * @param {object} user - from useAuth() — must have .uid
 */
export function logBitacora(venueId, logData, userInfo, user) {
  if (!venueId || !user?.uid) return;
  // Admin actions are excluded ("stealth mode")
  if (userInfo?.role === "admin") return;
  // Viewer e inversionista no escriben bitácora (las reglas solo dejan al
  // owner); intentarlo solo deja un error de permiso en consola.
  if (esSoloLectura(userInfo)) return;

  const bitacoraCol = collection(db, "venues", venueId, "bitacora");
  addDoc(bitacoraCol, {
    ...logData,
    userId: user.uid,
    userName: userInfo?.name || "",
    timestamp: serverTimestamp(),
  }).catch((err) => {
    console.warn("bitacora log failed:", err);
  });
}
